import { render, staticRenderFns } from "./UpgradeFromEnthusiastMsgModal.vue?vue&type=template&id=3c89cc96&scoped=true&"
import script from "./UpgradeFromEnthusiastMsgModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeFromEnthusiastMsgModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeFromEnthusiastMsgModal.vue?vue&type=style&index=0&id=3c89cc96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89cc96",
  null
  
)

export default component.exports